const english = {
    termsAndConditions: {
        acquisition: 'Acquisition and use of customer information',
        acquisitionText: 'When filing an insurance claim for this accident, we will obtain and use personal information such as your name, contact details, details of the accident, damage to the vehicle and its owner, and the condition of your injuries to the extent necessary to smoothly resolve the accident, pay appropriate insurance benefits, investigate the accident (including inquiries to medical institutions, repair companies, police, fire department, parties involved in the accident, etc.), and prevent and eliminate crimes such as fraudulent insurance claims.',
        provisionOfCustomerInformation: 'Provision of customer information to third parties',
        provisionOfCustomerInformationText: 'In order to settle the accident smoothly, pay the appropriate insurance claims, investigate the accident, and prevent and eliminate crimes such as fraudulent insurance claims, we may share the customer information we have acquired with the following third parties:',
        provisionOfCustomerInformationListHeader: 'Parties involved in the accident',
        provisionOfCustomerInformationList: ['insurance companies related to the parties involved in the accident',
                                             'insurance policyholders',
                                             'insurance contract handling agencies',
                                             'repair businesses',
                                             'police, fire departments'],
        provistionOfCustomerInformationEtc: 'etc',
        agree: 'Agree'
    },
    fnolInputForm: {
        submit: '送信',
        contactPersonName: 'Contact person\'s name',
        contactPersonPhoneNo: 'Contact person\'s phone number',
        relationshipWithContractors: 'Relationship with contractor',
        contractHolderNameKana: 'Contract holder name (kana)',
        contractHolderName: 'Contract holder name',
        subscriberPhoneNumber: 'Subscriber\'s phone number',
        registrationNumberOfTheContractedVehicle: 'Registration number of the contracted vehicle (e.g. Shinagawa 500 a 1234)',
        dateOfAccident: '[Date of accident]',
        timeOfAccident: '[Time of accident]',
        locationOfAccident: 'Location of accident',
        nameOfPersonWhoWasDrivingKana: 'Name of the person who was driving (kana)',
        nameOfPersonWhoWasDriving: 'The name of the person who was driving',
        contractHolder: 'Contract Holder',
        sex: 'Sex',
        dateOfBirth: '【date of birth】',
        age: 'Age',
        tel: 'TEL',
        sameAsContractedVehicle: 'Same as contracted vehicle',
        accidentVehicleRegistrationNumber: 'Accident vehicle registration number (e.g. Shinagawa 500 a 1234)',
        breifDescription: 'Please provide a brief description of the accident situation. Example 1: Car-to-car accident. When driving straight through an intersection, the car collided with an oncoming vehicle turning right.',
        otherContactInformation: 'Other contact information※Please enter any contact information you have.'
    }
}

export default english
